// extracted by mini-css-extract-plugin
module.exports = {"dialogTitle":"SelectVacancyDialog_dialogTitle_22Pjl","vacanciesList":"SelectVacancyDialog_vacanciesList_31NQn","vacancyTitle":"SelectVacancyDialog_vacancyTitle_12Fy5"};